<mat-form-field *transloco="let t; read: tPrefix" class="width100">
  <mat-label>{{ t('title') }}</mat-label>
  <mat-select [formControl]="control">
    <mat-option *ngFor="let result of results" [value]="result.value">
      {{ result.label }}
    </mat-option>
  </mat-select>
</mat-form-field>
